$(document).ready(function(){
  var now = new Date();
  var formattedDateTime = now.toLocaleString();
  console.log(formattedDateTime)
  $("button.start-quiz").on("click", function(){
    $(".quiz-banner-section").hide();
    $("body").addClass("quiz-start");
    $(".quiz-flow-step[step-count='1']").show();
  })
  $("button.quiz-exit").on("click", function(){
    $(".quiz-banner-section").show();
    $("body").removeClass("quiz-start");
    $(".quiz-flow-step").hide();
    $(".quiz-flow-step").find("input").prop("checked", false);
    $(".next-button").attr("disabled", "disabled");
    $(".results-main").html("")
  })
  $(".back-to-remove-results").on("click", function(){
    $(".results-main").html("")
  });
  $("label.option-container-in input").on("change", function(){
   $(this).parents(".quiz-flow-step").find("button.next-button").removeAttr("disabled"); 
  })
  $("button.next-button").on("click", function(){
    var get = $(this).attr("data-step");
    $(".quiz-flow-step[step-count='"+get+"']").show();
    $(".quiz-flow-step[step-count='"+get+"']").prevAll(".quiz-flow-step").hide();
    $(".quiz-flow-step[step-count='"+get+"']").nextAll(".quiz-flow-step").hide();
  })
  $("button.prev-button").on("click", function(){
    var get = $(this).attr("data-step");
    $(".quiz-flow-step[step-count='"+get+"']").show();
    $(".quiz-flow-step[step-count='"+get+"']").prevAll(".quiz-flow-step").hide();
    $(".quiz-flow-step[step-count='"+get+"']").nextAll(".quiz-flow-step").hide();
  })
  $("label.option-container-in").on("click", function(){
    console.log("trigger click");
    if ( $(this).find("input").is(":checked") )
    {
      $(this).parents(".quiz-flow-step").find("button.next-button").trigger("click");
    }
  })
  var options = [];
  var results = [];
  $(".final-result-call").on("click", function(){
    $("#quiz-kit-spinner").show();
    $(".hide-when-load").show();
    options = [];
    
    //e.preventDefault();
    $(".step-in-use").each(function(){
      var get = $(this).find("input:checked").val();
      options.push(get)
     
    })
    var text = options.join("+");
    console.log(text)
    var first = $(".quiz-flow-step.step-in-use[step-count='1']").find("input:checked").val().toLowerCase();
    var second = $(".quiz-flow-step.step-in-use[step-count='2']").find("input:checked").val().toLowerCase();
    var sectionID = first+"-"+second;
    console.log(sectionID);
    // fetch('/?sections='+sectionID)
    // .then(response => response.json())
    // .then(data => {
    //   createHTMLFromJSON(data);
    //   var text = createHTMLFromJSON(data);
    //   console.log(text)
    // })
    // .catch(error => console.error('Error fetching data:', error));
    $.ajax({
        url: '/?sections='+sectionID,
        type: 'GET',
        async:true,
        dataType:"json",
        success: function(data) {
          
          const jsonData = data;
    
          // Extract the HTML from the JSON object
          const htmlContent = jsonData[sectionID];
    
          // Insert the HTML into the content div
          $("#quiz-kit-spinner").hide();
          $(".hide-when-load").hide();
          $(".results-main").html(htmlContent);
          $(".result-product-bar[result-match='"+text+"']").show();
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error fetching line-item-list content:", errorThrown);
          alert("Something went wrong. Please try again.");
          $("#quiz-kit-spinner").hide();
        }
      });
    //$(".result-product-bar[result-match='"+text+"']").show();
  })
  $(".option-item input").on("change", function(){
    
    var stepCount =  $(this).parents(".quiz-flow-step").attr("step-count");
    var thiss = $(this);
    if (stepCount == "5")
    {
      setTimeout(function(){
      thiss.parents(".quiz-flow-step").hide();
      thiss.parents(".quiz-flow-step").next(".quiz-flow-step").show();
      thiss.parents(".quiz-flow-step").find(".final-result-call").trigger("click");
        }, 400);
    }
    else
    {
      setTimeout(function(){
      thiss.parents(".quiz-flow-step").hide();
      thiss.parents(".quiz-flow-step").next(".quiz-flow-step").show();
        }, 400);
    }
    
  })

  $(".custom-newsletter-submit").on("click", function(e){
        
        
        $(".button-submit-text").hide();
        $(".spinner-buttom").show();
        var getemail = $(this).parents("form").find(".input-group__field").val();        
        if ( getemail != ""  )
        { 
          e.preventDefault()
          if( !isValidEmailAddress( getemail ) ) {
            alert("Email is invalid");
          }
          else
          {
            options = [];
            results = [];
    //e.preventDefault();
    $(".step-in-use").each(function(){
      var get = $(this).find("input:checked").val();
      options.push(get)
     
    })
    var text = options.join("+");
            var first = $(".quiz-flow-step.step-in-use[step-count='1']").find("input:checked").val().toLowerCase();
    var second = $(".quiz-flow-step.step-in-use[step-count='2']").find("input:checked").val().toLowerCase();
    var sectionID = first+"-"+second;
            $.ajax({
        url: '/?sections='+sectionID,
        type: 'GET',
        async:true,
        dataType:"json",
        success: function(data) {
          
          const jsonData = data;
    
          // Extract the HTML from the JSON object
          const htmlContent = jsonData[sectionID];
    
          // Insert the HTML into the content div
          //$("#quiz-kit-spinner").hide();
          //$(".hide-when-load").hide();
          $(".results-main").html(htmlContent);
          //$(".result-product-bar[result-match='"+text+"']").show();
          //$(".result-product-bar[result-match='"+text+"']").addClass("cuurently-showing");
          $(".result-product-bar[result-match='"+text+"']").find(".prodiucts-bar .grid-item.product-item").each(function(){
            var title = $(this).find("p.product-item__title").text();
            results.push(title);
          })
          console.log(results)

          console.log("email is valid");
            $(this).find("span.btn-intext").hide();
            $(this).find(".loader").show();
            var data1 = jQuery(this).parents("form").serialize();
            console.log(data1)
        
            
            $.ajax({
          type:"post",
          url:"https://apikovessentials.com/kove-klaviyo/index.php?email="+getemail+"&date="+formattedDateTime+"&result="+results,
          async: true,
          headers: {
                   "content-type": "application/json",
                  "Access-Control-Allow-Origin": '*',
                   "cache-control": "no-cache"
                 },    
          crossDomain: true,
          success:function(data)
            {
              console.log(data);
              console.log('Profile subscribed successfully:', response);
              $(".button-submit-text").text("Subscribed");
                  setTimeout(function(){
                  $(".button-submit-text").text("Submit & See Results");
                  $(".button-submit-text").show();
                  $(".spinner-buttom").hide();
                  $(".final-result-call").trigger("click");
                    }, 500);
            },
                error: function(xhr, status, error) {
                    console.error('Failed to subscribe profile:', xhr.responseText);
                  $(".button-submit-text").text("Subscribed");
                  setTimeout(function(){
                  $(".button-submit-text").text("Submit & See Results");
                  $(".button-submit-text").show();
                  $(".spinner-buttom").hide();
                  $(".final-result-call").trigger("click");
                    }, 500);
                }
        })
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error("Error fetching line-item-list content:", errorThrown);
          alert("Something went wrong. Please try again.");
          $("#quiz-kit-spinner").hide();
        }
      });
            
          }
        }
        else
        {
          alert("All form fields are required!")
          $(".button-submit-text").show();
          $(".spinner-buttom").hide();
        }
      })
  function isValidEmailAddress(emailAddress) {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
};
  $(document).on('click','.result-product-bar .swatches.swatch__button',function(e){
  //$(".result-product-bar .swatches.swatch__button").on("click", function(e){
    e.preventDefault();
    e.stopPropagation();
    $(this).find(".sibling__link").addClass("sibling__link--current");
    $(this).prevAll(".swatches.swatch__button").find(".sibling__link").removeClass("sibling__link--current");
    $(this).nextAll(".swatches.swatch__button").find(".sibling__link").removeClass("sibling__link--current");
    var getImage = $(this).attr("data-sibling-image");
    var getPrice = $(this).attr("data-sibling-price");
    var getTitle = $(this).attr("variant-title");
    var getVariantId = $(this).attr("vriant-id");
    var getPurl = $(this).attr("data-sibling-url");
    $(this).parents(".grid-item").find("p.product-item__title").text(getTitle)
    $(this).parents(".grid-item").find("p.product-item__title span.new-price").text(getPrice)
    $(this).parents(".grid-item").find("quick-add-product input[name='id']").val(getVariantId)
    $(this).parents(".grid-item").find(".product-item__bg figure.image-wrapper").find("img").attr("srcset",getImage)
    $(this).parents(".grid-item").find(".product-item__image a.product-link").attr("href",getPurl)
  })
  $("input#agree-to-subscribe").on("change", function(){
    if($(this).is(":checked"))
    {
      $("button.caps.newsletter__submit.input-group__btn.custom-newsletter-submit").removeAttr("disabled");
    }
    else
    {
      $("button.caps.newsletter__submit.input-group__btn.custom-newsletter-submit").attr("disabled","disabled");
    }
  })
})